import React from 'react';
import { Button, Input, Select } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import fp from '../../../utils/fp';

const Option = Select.Option;

class Filter extends React.Component {
    state = {
        searchParams: {},
        noPage: true,
        expand: false,
        businessList: [],
    }

    componentDidMount() {
        const { handoverCode } = this.props;
        const { searchParams } = this.state;
        if (handoverCode) {
            if (handoverCode.indexOf('code_') > -1) {
                searchParams.handoverCode = param.slice(5)
                this.setState({ searchParams });
            }
        }
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleAdd = () => {
        this.props.update({}, 'add');
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({ searchParams });
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({ ...searchParams });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }
    export = () => {
        this.props.export();
    }

    toggleHeight = () => {
        const { expand } = this.state;
        this.setState({ expand: !expand });
    }

    render() {
        const { searchParams, expand, businessList } = this.state;
        const {
            invCode,
            invName,
            handoverCode,
            city,
            siteCode,
            siteName,
            handoverUser,
            assignedUser,
            assignUser,
            requireUser,
            lineOfBusiness,
        } = searchParams;
        const { curRole, invState, crcSourcePlatformUrl } = sessionStorage;
        const showCrcSourcePlatform = (invState == 0) && fp.contains(curRole,['BO', 'CSAL', 'CRCC', 'CRCM'])
        const isShow = curRole != "BD" && curRole != 'TAL' && curRole != 'BDO' && curRole != 'CRC' && curRole != "BA" && curRole != 'BAL';
        const maxHeight = expand ? 120 : 40;

        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        return (
            <div>
                <div className="filter-bar" style={{ width: '100%', marginBottom: 0, overflow: 'hidden', maxHeight: 'unset', transition: 'all .1s linear 0s' }}>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">交接编号</label>
                        <Input
                            value={handoverCode}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'handoverCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">项目编号</label>
                        <Input
                            value={invCode}
                            placeholder="请输入"
                            onChange={e => this.handleChange(e.target.value, 'invCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">项目简称</label>
                        <Input
                            value={invName}
                            placeholder="请输入"
                            onChange={e => this.handleChange(e.target.value, 'invName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    {
                        isShow &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">城市</label>
                            <Input
                                value={city}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'city')}
                                onKeyPress={this.enterSearch}
                            />
                        </div>
                    }
                    {
                        isShow &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">中心编号</label>
                            <Input
                                value={siteCode}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'siteCode')}
                                onKeyPress={this.enterSearch}
                            />
                        </div>
                    }
                    {
                        isShow &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">中心名称</label>
                            <Input
                                value={siteName}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'siteName')}
                                onKeyPress={this.enterSearch}
                            />
                        </div>
                    }
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">状态</label>
                        <Select
                            onChange={value => this.handleChange(value, 'status')}
                            style={{ width: 90 }}
                            placeholder="请选择"
                            allowClear={true}
                        >
                            <Option value="NEW">新建</Option>
                            <Option value="ASSIGNED">预分配</Option>
                            <Option value="REASSIGNED">重新分配</Option>
                            <Option value="REJECTED">被拒绝</Option>
                            <Option value="HANDOVER_RECALL">被撤回</Option>
                            <Option value="UNDERWAY">进行中</Option>
                            <Option value="RECEIVED">已提交</Option>
                            <Option value="ACTIVE">已完成</Option>
                        </Select>
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">交接人</label>
                        <Input
                            value={handoverUser}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'handoverUser')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">接收人</label>
                        <Input
                            value={assignedUser}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'assignedUser')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">发起人</label>
                        <Input
                            value={requireUser}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'requireUser')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">处理人</label>
                        <Input
                            value={assignUser}
                            placeholder="请输入"
                            style={{ width: 100 }}
                            onChange={e => this.handleChange(e.target.value, 'assignUser')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                </div>
                <div className="filter-bar" style={{display: 'block'}}>
                    <div className="filter-bar-investigation" style={{ float: 'right' }}>
                        {
                            showCrcSourcePlatform &&
                            <Button style={{ color: '#FFF', background: '#62cf96', border: '1px solid #62cf96' }} onClick={() => window.open(atob(crcSourcePlatformUrl))}>CRC资源平台</Button>
                        }
                        {
                            (curRole == 'PM' || curRole == 'PA') && this.props.src == "Execute" ? <Button type="primary" onClick={this.handleAdd}>新建</Button> : ''
                        }
                        <Button type="primary" onClick={this.export}>导出</Button>
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/user/transfer/CRCFilter.js